export default __webpack_public_path__ + "static/media/UPLOAD.ecdec2e3.PNG";